import ThreadMessageIcon from './ThreadMessageIcon';

const ThreadMessageUnfollow = () => (
  <ThreadMessageIcon
    className='rcx-box rcx-box--full rcx-message-thread__icon rcx-message-thread__icon--unfollow'
    name='bell-off'
  />
);

export default ThreadMessageUnfollow;
